import Vue from 'vue'
import Vuex from 'vuex'
import VueIdb from './idb'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hydrated: false,
    spSlide: false,
    composePot: false,
    list: '',
  },
  mutations: {
    toggleSpSlide(state, val){
      if(val !== undefined){
        state.spSlide = val
      }else{
        state.spSlide = state.spSlide? false: true;
      }
    },
    toggleComposePot(state, val){
      if(val){
        state.composePot = val
      }else{
        state.composePot = state.composePot? false: true;
      }
    },
    'DELETE_INDEXED_DB'(){}
  },
  actions: {
    toggleSpSlide({ commit }, val) {
      commit('toggleSpSlide', val)
    },
    toggleComposePot({ commit }) {
      commit('toggleComposePot')
    },
  },
  modules: VueIdb.modules,
  plugins: [ VueIdb.plugin ],
  getters: {
    spSlide(state) {
      return state.spSlide;
    },
    composePot(state) {
      return state.composePot;
    },
    hydrated: state => state.hydrated
  },
  strict: true
})
